module.exports = __webpack_public_path__ + "img/Forbidden.eeba3333.gif";